// extracted by mini-css-extract-plugin
export default {"bee":"Bee_bee__418Tr","honey":"Bee_honey__SMyoO"};